export default {
  PASS: 'Passed',
  FAILED: 'Failed'
};
